import { ChangeDetectorRef, Component, Injector, OnInit, HostListener } from '@angular/core';
import { finalize,map,tap } from 'rxjs/operators';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { OrderService, PlacedOrderDisplayModel, OrderStatus, IDeliveryAddress } from 'src/app/store/services/order.service';
import { PageService } from 'src/app/services/page.service';
import { StoreService } from 'src/app/store/services/store.service';
import { Router } from '@angular/router';
import { IStoreMenu } from 'src/app/store/services/store.service';
import { IAddress } from '../profile-page/profile-page.component';
//import * as moment from 'moment';
import moment from 'moment';
import { combineLatest} from 'rxjs';
import { ModalController, NavParams } from '@ionic/angular';
import { ConfirmReorderComponent } from '../../confirm-reorder/confirm-reorder.component';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ElementRef } from '@angular/core';
import { NotificationServiceService, INotifications } from 'src/app/store/services/notification-service.service';
import { NotificationBellServiceService } from 'src/app/store/services/notification-bell-service.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { IconService } from 'src/app/shared/services/icon.service';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-order-list-page',
    templateUrl: './order-list-page.component.html',
    styleUrls: ['./order-list-page.component.scss'],
    standalone: false
})
export class OrderListPageComponent implements OnInit {
  title: string = 'Nav.MyOrders';
  orders: PlacedOrderDisplayModel[] = [];
  isDelivery: boolean;
  storeId: string;
  orderType: string;
  change: boolean=false;
  destroy: any;
  Details: string='Details';
  ReOrder: string='ReOrder';
  unavailableItems: any[] = [];
  unavailableOptions: any[] = [];
  changedPriceItems: any[] = [];
  deliveryAddress: IDeliveryAddress;

  valideNotification: number;
  AllNotifications: INotifications[];

  disableHeader: boolean = false;
  isPopup: boolean = false;
  mobile: boolean = false;

  bellIcon: IconDefinition;

  ///////////////////////////////////////////////////
  // pagination
  pageSize = 15;
  paginatedOrders: any[] = [];

  onPageChange(event: PageEvent) {
    const startIndex = event.pageIndex * event.pageSize;
    const endIndex = startIndex + event.pageSize;

    this.paginatedOrders = this.orders.slice(startIndex, endIndex);
  }
  ///////////////////////////////////////////////////

  getCurrentPath(): string {
    return this.router.url;
  }
  
  get totalPages(): number {
    return Math.ceil(this.orders.length / this.pageSize);
  }
  
  constructor(private orderService: OrderService,
              private loaderService: LoaderService,
              private router: Router,
              private storeService: StoreService,
              private page: PageService, //Page Service link
              //private translate: TranslateService,
              private modalController: ModalController,
              private el: ElementRef,
              private cdr: ChangeDetectorRef,
              public NotificationService: NotificationServiceService,
              public NotificationBellService: NotificationBellServiceService,
              private injector: Injector,
              public setting: SettingService,
              private analytics: AnalyticsService,
              private iconService: IconService,
              private translationService: TranslationService
              ) {
                this.bellIcon = this.iconService.getIcon('bell')!;
              }

  async ngOnInit() {

    // Only access NavParams if running inside a modal
    const navParams = this.injector.get(NavParams, null);
    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
        this.isPopup = true;
      }
    } catch (e) {

    }

    if(!this.isPopup) {
      var currentUrl = this.getCurrentPath();
      localStorage.setItem('Stateurl', currentUrl);
    } else {
      localStorage.setItem('Stateurl', 'popup-orderlist');
    }
    

    this.analytics.UpdateLocation({url: "/account/my-orders", ispopup: this.isPopup},  true, false);

    try {
      this.valideNotification = await this.NotificationService.notificationCount();
      this.AllNotifications = this.NotificationService.notifationArray;
    } catch (e) {
      console.log("error collecting Notification Data");
    }

    this.getOrders();
    this.page.getDetails(false);

    if (window.innerWidth <= 600) { // follows the value of the modal
      this.mobile = true;

      if(this.setting.configuration.uIoptions?.myOrdersToPopup) {
        this.disableHeader = false;
      }
    } else {
      this.mobile = false;

      if(this.setting.configuration.uIoptions?.myOrdersToPopup) {
        this.disableHeader = true;
      }
    }

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();
  }

  ngOnDestroy()
  { 
   this.el.nativeElement.remove()
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) { 

    if (window.innerWidth <= 600) { // follows the value of the modal
      this.mobile = true;

      if(this.setting.configuration.uIoptions?.myOrdersToPopup) {
        this.disableHeader = false;
      }
    } else {
      this.mobile = false;

      if(this.setting.configuration.uIoptions?.myOrdersToPopup) {
        this.disableHeader = true;
      }
    }
  }  

  getStatusTranslation(order: PlacedOrderDisplayModel) {
    if (order.orderStatus == OrderStatus.Initialized)
        return this.translationService.translate('Order.New');

    if (order.orderStatus == OrderStatus.Accepted)
        return this.translationService.translate('Order.OrderAccepted');

    if (order.orderStatus == OrderStatus.Prepare)
        return this.translationService.translate('Order.PreparingOrder');

    if(order.isShipping){
      if (order.orderStatus == OrderStatus.ReadyForShipping)
        return this.translationService.translate('Order.ReadyForShipping');
    } else {
      if (order.orderStatus == OrderStatus.ReadyForPickup) {
        if (order.isDelivery)
            return this.translationService.translate('Order.ReadyForDelivery');

        return this.translationService.translate('Order.ReadyForPickup');
      }
    }

    if(order.isShipping){
      if (order.orderStatus == OrderStatus.OutForShipping)
        return this.translationService.translate('Order.OutForShipping');
    } else {
      if (order.orderStatus == OrderStatus.OutForDelivery)
        return this.translationService.translate('Order.OutForDelivery');
    }

    if (order.orderStatus == OrderStatus.Completed)
        return this.translationService.translate('Order.Completed');

    return this.translationService.translate('Order.New');
  }

  async getOrders() {
    const loader = await this.loaderService.create();
    await loader.present();

    setTimeout(() => {
      loader.dismiss()
    }, 15000);
    combineLatest([
      this.orderService.findMemberAllPlacedOrder(),
      this.storeService.getStores(true)
    ]).pipe(
      map(([orders, stores]) => {
       /*
        return orders.map(order => {
            let store = stores.find(store => store.id === order.storeId);
            console.log(store);
            return {
              ...order,
              storeName: store.displayName,
              storeAllowSales: store.allowSales
            }
        })
        */

        return orders.map(order => {
          const store = stores.find(store => store.id === order.storeId);

          // Skip this order if no matching store was found
          if (!store) {
            return null;
          }

          return {
            ...order,
            storeName: store.displayName ?? null,
            storeAllowSales: store.allowSales ?? null
          };
        })
        .filter(order => order !== null);
      })
    ).subscribe(orders => {
      combineLatest([
        this.orderService.findMemberAllPlacedOrderShipping(),
        this.storeService.getStores(true)
      ]).pipe(
        finalize(() => {
          console.log("dismiss loader");
          loader.dismiss();
        }),  
        /* 
        map(([ordersShipping, stores]) => {
          const storeMap = new Map(stores.map(s => [s.id, s]));
          return ordersShipping
            .filter(orderShipping => storeMap.has(orderShipping.storeId)) // remove invalid ones
            .map(orderShipping => {
              const store = storeMap.get(orderShipping.storeId)!;

              return {
                ...orderShipping,
                storeName: store.displayName,
                storeAllowSales: store.allowSales
              };
            });
        })
        */

        map(([ordersShipping, stores]) => {
          const storeMap = new Map(stores.map(s => [s.id, s]));

          return ordersShipping
          // Skip records where the store itself cannot be found
          .filter(orderShipping => storeMap.has(orderShipping.storeId))
          .map(orderShipping => {
          const store = storeMap.get(orderShipping.storeId)!;

            return {
              ...orderShipping,
              storeName: store.displayName ?? null,
              storeAllowSales: store.allowSales ?? null
            };
          });
        })

      ).subscribe(ordersShipping => {

        let allOrders = orders.concat(ordersShipping);

        this.orders = allOrders.sort((a, b) => {
          let aDate: moment.Moment = moment(a.date);
          let bDate: moment.Moment = moment(b.date);
          return bDate.diff(aDate);
        });

        this.paginatedOrders = this.orders.slice(0, this.pageSize);
      })
    });

    
  }

async reOrder(pastOrder: PlacedOrderDisplayModel) { 

  if(this.isPopup) {
    this.modalController.dismiss();  
  }
  

  const loader = await this.loaderService.create();
  await loader.present();

  //later check something more suitable 
  this.destroy = this.storeService.getMenu(pastOrder.storeId,undefined,undefined)
  .pipe(finalize(()=>{
    loader.dismiss()
  }),map(data=>{
    return data.storeMenuCategories.map(item1=>{
      return item1.storeMenuCategoryItems.map(item2=>{
           return({ itemOptionCategories: item2.item.itemOptionCategories,
                    name: item2.item.itemName,
                    itemId: item2.item.id,
                    price: item2.item.price,
                    taxEligible: item2.item.taxEligible, //missing
                    itemDetailCombination: item2.item.itemDetailCombination ? item2.item.itemDetailCombination : null,
                    colors: item2.item.itemColors,
                    sizes: item2.item.itemSizes,
                    quantity: item2.item.quantity,
                    isInventoryExist: item2.item.isInventoryExist,
                    isInventoryActive: item2.item.isInventoryActive,
                    _hidePrice: false,
                    isDelivery: item2.item.isDelivery,
                    itemAvailableHour: item2.item.itemAvailableHour,
                    isActive: item2.item.isActive})  
          })
     })
  }))
  .subscribe(menu=>{
    let mergedMenu=[];

    for(let i=0;i<menu.length;i++)
    {
      mergedMenu=mergedMenu.concat(menu[i]);
    }

    this.orderService.findPlacedOrderById(pastOrder.orderId)
    .pipe(map(data=>{
      this.isDelivery=data.isDelivery;
      this.deliveryAddress=data.deliveryAddress;
      this.storeId=data.storeId;
      //p start
      return data.items.map(p=>{ 
        let item=mergedMenu.filter(item=>item.itemId==p.id); //we need id on ordered products
        let originalItem=item[0];
        if(!originalItem)
        {
          this.unavailableItems.push(p);
          return;
        }
        if(p.itemDetailCombination)
        {
          let itemColor=originalItem.colors.find(item=> item.id==p.itemDetailCombination.colorId);
          let itemSize=originalItem.sizes.find(item=>item.id==p.itemDetailCombination.sizeId);
          if(!itemColor || !itemSize)
          {
            this.unavailableItems.push(p);
            return;
          }
        }
        if(!originalItem.isActive){
          this.unavailableItems.push(p);
          return;
        } 
        if((originalItem.isInventoryExist && originalItem.isInventoryActive))
        {
          if(originalItem.quantity==0)
          {
            this.unavailableItems.push(p);
            return;
          }
        } 

        p.options.map(option1=>{
      
            originalItem.itemOptionCategories.map(menu=>{
              if(option1.id != null){
                let originalOption=menu.options.find(option=>option.optionId==option1.id);//ask about ID and also about that sometimes items don't have name
                if(originalOption)
                {
                  option1.optionId = option1.id;
                  option1.name = originalOption.option.name;
                  option1.itemOptionCategoryId = menu.id;
                  if(option1.price!=originalOption.option.price) 
                  { 
                    this.change=true;
                    option1.price=originalOption.option.price;
                  }
                }
              } else if (option1.itemId != null){
                for(let option of menu.options){
                  if(option.option && option.option.categoryItems && option.option.categoryItems.length > 0){
                    let originalOption=option.option.categoryItems.find(item=>item.itemId==option1.itemId);//ask about ID and also about that sometimes items don't have name
                    if(originalOption)
                    {
                      option1.optionId = null;
                      option1.name = originalOption.name;
                      option1.itemNumber = originalOption.itemNumber;
                      option1.itemOptionCategoryId = menu.id;
                      if(option1.price!=originalOption.price) 
                      { 
                        this.change=true;
                        option1.price=originalOption.price;
                      }
                    }
                  }
                }
              }
            })
            
        });

        if(originalItem.itemDetailCombination && p.itemDetailCombination)
        {
          originalItem.itemDetailCombination.map(item=>{
          
            if(item.id==p.itemDetailCombination.id)
            {
              if(item.price !== p.itemDetailCombination.price || item.code !== p.itemDetailCombination.code )//item.sizeId !==p.itemDetailCombination.sizeId || item.colorId !== p.itemDetailCombination.colorId
              {
                p.itemDetailCombination.price=item.price;
                this.change=true;
              }
            }
          });
        }
        if(originalItem.price==p.price)
        { 
          return {
            itemId: originalItem.itemId,
            itemName: originalItem.name, 
            itemNumber: p.itemNumber,
            options: p.options, 
            taxEligible: originalItem.taxEligible, //missing
            price:  p.itemDetailCombination ? p.itemDetailCombination.price : originalItem.price, //p.totalPrice cannot use p.price,
            quantity: p.quantity,
            allergies: p.allergies,
            note: p.note,
            _chainItemId: null, //missing
            _hidePrice: false, //linked to override price,
            itemDetailCombination: p.itemDetailCombination,
            itemAvailableHour: originalItem.itemAvailableHour,
            isDelivery: originalItem.isDelivery,
            orderType: this.isDelivery ? "delivery" : "pickup"
          }
        }
        else if(originalItem.price != p.price){ 
          this.change=true;
          if(!this.changedPriceItems.some(item => item.itemId == p.id)){
            this.changedPriceItems.push({
              itemId: p.id,
              itemName: p.name,
              oldPrice: p.price,
              newPrice: originalItem.price
            });
          }
          return {
            itemId: originalItem.itemId,
            itemName: originalItem.name, 
            itemNumber: p.itemNumber,
            options: p.options, 
            taxEligible: originalItem.taxEligible, //missing
            price: p.itemDetailCombination ? p.itemDetailCombination.price : originalItem.price, //p.totalPrice cannot use p.price,
            quantity: p.quantity,
            allergies: p.allergies,
            note: p.note,
            _chainItemId: null, //missing
            _hidePrice: false, //linked to override price,
            itemDetailCombination: p.itemDetailCombination,
            itemAvailableHour: originalItem.itemAvailableHour,
            isDelivery: originalItem.isDelivery,
            orderType: this.isDelivery ? "delivery" : "pickup"
          }
        }                                               
      })
    }))
    .subscribe((order) => {
      order = order.filter(i => i != undefined);
      if(order.length == 0)
      {
        this.modalController.create({
          component: ConfirmReorderComponent,
          componentProps: {
            noItem: true
          },
          cssClass: 'my-custom-modal-css3'
        }).then(modalres=>{
          modalres.present();
          this.resetValues();
        });
        return;
      }
      if(this.unavailableItems.length > 0)
      {
        this.modalController.create({
          component: ConfirmReorderComponent,
          cssClass: 'my-custom-modal-css4',
          componentProps: {
            item: order,
            unavailableItems: this.unavailableItems,
            changedPriceItems: this.changedPriceItems,
            change: this.change,
            storeId: this.storeId,
            orderType: this.isDelivery ? 'delivery' : 'pickup',
            deliveryAddress: this.deliveryAddress
          }
          }).then(modalres=>{
            modalres.present();  
            this.resetValues();
          });
        return;
      }

      if(!this.change){
        this.modalController.create({
          component: ConfirmReorderComponent,
          componentProps: {
            item: order,
            change: this.change,
            storeId: this.storeId,
            orderType: this.isDelivery ? 'delivery' : 'pickup',
            deliveryAddress: this.deliveryAddress
          },
          cssClass: 'my-custom-modal-css4'
        }).then(modalres=>{
          modalres.present();
          this.resetValues();
        });
      }
      else { 
        this.modalController.create({
          component: ConfirmReorderComponent,
          componentProps: {
            item: order,
            change: this.change,
            storeId: this.storeId,
            orderType: this.isDelivery ? 'delivery' : 'pickup',
            changedPriceItems: this.changedPriceItems,
            deliveryAddress: this.deliveryAddress
          },
          cssClass: 'my-custom-modal-css4'
        }).then(modalres=>{
          modalres.present();
          this.resetValues();
        });
      }
    })
  })
  
}

  resetValues(){
    this.unavailableItems = [];
    this.unavailableOptions = [];
    this.changedPriceItems = [];
  }
  
  detail(id: string, isShipping: boolean) { 

    if(this.isPopup) {
      this.modalController.dismiss(); 
    }

    this.page.getDetails(true);
    if(isShipping){
      this.router.navigateByUrl(`/shipping/tracking/${id}`); 
    } else {
      this.router.navigateByUrl(`/order/tracking/${id}`);
    }
  }

  closePopup(){
    if(this.isPopup) {
      this.modalController.dismiss();
    }
  }
}
